// revert-LSW-157
/* eslint-disable no-nested-ternary */
// Dependencies
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Accordion, Tooltip } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Moment from 'react-moment';
import moment from 'moment';
import Dropdown from 'react-bootstrap/Dropdown';
import PropTypes from 'prop-types';
import { DatePicker, Pagination } from 'antd';
import 'antd/dist/antd.css';
import { withTranslation } from 'react-i18next';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// Component
import Template from '../../components/Template';
import PopUp from '../../components/Modal';
import Spinner from '../../components/Spinner';
import RenderTooltip from '../../components/RenderTooltip';
import FormInProcess from '../../components/Maintenance/FormInProcess';
import FormAdditionalApproval from '../../components/Maintenance/FormAdditionalApproval';
import AdditionalApprovalsHistory from '../../components/Maintenance/AdditionalApprovalsHistory';
import TableSelectedParts from '../../components/TableSelectedParts';
// Hooks
import useStatusService from '../../hooks/useStatusService';

// Images
import alert from '../../../sass/images/alert/alert.svg';
import arrowDown from '../../../sass/images/icons/arrow-down.svg';
import arrowUp from '../../../sass/images/icons/arrow-up.svg';
import moreVertical from '../../../sass/images/icons/more-vertical.svg';
import alertIcon from '../../../sass/images/icons/modal-alert.svg';
import calendarIcon from '../../../sass/images/icons/calendar-day.svg';
import notMaintenance from '../../../sass/images/not-maintenance.svg';
import eye from '../../../sass/images/ver-ocultar.svg';

// Utils
import { urlPublicS3 } from '../../helpers';

function Maintenance(props) {
  const [activeKey, setActiveKey] = useState(0);
  const {
    reload,
    maintenances,
    newMaintenances,
    openModal,
    openModalCancel,
    openModalChangeInProcess,
    openModalChangeInApproval,
    openModalSatisfactionQuestionnaire,
    openModalStars,
    openModalLeft,
    openModalRequestReject,
    openModalAccept,
    openModalDeny,
    closeModal,
    acceptModal,
    acceptModalChangeInProcess,
    acceptModalChangeInApproval,
    acceptModalSatisfactionQuestionnaire,
    acceptModalLeft,
    idService,
    onSubmit,
    onSubmitSatisfactionQuestionnaire,
    changeInProcess,
    changeInApproval,
    satisfactionQuestionnaire,
    dateInitial,
    dateFinal,
    useSetFilterDate,
    onChangeInitial,
    onChangeFinal,
    star,
    setStar,
    CustomToggle,
    Toggle,
    arrow,
    activeKeyStatus,
    confirmCancel,
    dataMaintenance,
    dataGarage,
    messageAlertInApproval,
    textMessageAlertInApproval,
    messageQuestionnaire,
    setDataFormInApproval,
    openModalAdditionalApproval,
    openAdditionalApprovalModal,
    acceptModalAdditionalApproval,
    messageAlertAdditionalApproval,
    setDataFormAdditionalApproval,
  } = useStatusService();
  const { t } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [cardPerPage] = useState(6);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(cardPerPage);
  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];
  // change page
  const handleChange = (page) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * cardPerPage);
    setMaxIndex(page * cardPerPage);
  };
  const hourChange = (time) => moment(time, 'hh:mm a');
 

   
  return (
    <Template
      type={3}
      newMaintenances={newMaintenances}
      classNameContainer="maintenance"
      className="container_menu maintenance"
    >
      <>
        {openModal ? (
          <PopUp
            open={openModal}
            close={closeModal}
            icon={alertIcon}
            title={t('title-open-modal')}
            back={t('cancel')}
            go={t('yes-accept')}
            accept={acceptModal}
            modalDesign
            btnAccept
            btnClose
            classNameContent="modal-confirm"
            classNameBtn="btn_modal pink"
          />
        ) : (
          ''
        )}

        {openModalCancel ? (
          <PopUp
            open={openModalCancel}
            close={closeModal}
            icon={alertIcon}
            title={t('title-open-modal-cancel')}
            description={t('description-cancel')}
            back={t('keep-it')}
            go={t('yes-cancel')}
            accept={acceptModalLeft}
            modalDesign
            btnAccept
            btnClose
            classNameBase="block-modal-left"
            classNameContent="modal-left"
            classNameBtn="btn_modal pink"
          />
        ) : (
          ''
        )}
        {openModalChangeInProcess ? (
          <PopUp
            open={openModalChangeInProcess}
            close={closeModal}
            icon={alertIcon}
            title={t('title-open-modal-in-process')}
            back={t('cancel')}
            go={t('yes-change')}
            accept={acceptModalChangeInProcess}
            modalDesign
            btnAccept
            btnClose
            classNameContent="modal-confirm"
            classNameBtn="btn_modal pink"
          />
        ) : (
          ''
        )}

        {openModalChangeInApproval ? (
          <PopUp
            open={openModalChangeInApproval}
            close={closeModal}
            icon={alertIcon}
            title={t('title-open-modal-in-approval')}
            back={t('cancel')}
            go={t('yes-change')}
            accept={acceptModalChangeInApproval}
            modalDesign
            btnAccept
            btnClose
            classNameContent="modal-confirm"
            classNameBtn="btn_modal pink"
          />
        ) : (
          ''
        )}

        {openModalAdditionalApproval ? (
          <PopUp
            open={openModalAdditionalApproval}
            close={closeModal}
            icon={alertIcon}
            title={t('title-open-modal-additional-approval')}
            back={t('cancel')}
            go={t('yes-change')}
            accept={acceptModalAdditionalApproval}
            modalDesign
            btnAccept
            btnClose
            classNameContent="modal-confirm"
            classNameBtn="btn_modal pink"
          >
            <FormAdditionalApproval
              id={idService}
              dataForm={setDataFormAdditionalApproval}
            />
            {messageAlertAdditionalApproval && (
              <div className="error_input">
                <p>
                  <img src={alert} alt={t('alt:notification')} />
                  {t('maintenance:validate-additional-approval')}
                </p>
              </div>
            )}
          </PopUp>
        ) : (
          ''
        )}

        {openModalSatisfactionQuestionnaire ? (
          <PopUp
            open={openModalSatisfactionQuestionnaire}
            close={closeModal}
            icon={alertIcon}
            title={t('title-open-modal-satisfaction-questionnaire')}
            back={t('cancel')}
            go={t('continue')}
            accept={acceptModalSatisfactionQuestionnaire}
            modalDesign
            btnAccept
            btnClose
            classNameContent="modal-confirm"
            classNameBtn="btn_modal pink"
            alertError={messageQuestionnaire}
          />
        ) : (
          ''
        )}
        {openModalStars ? (
          <PopUp
            open={openModalStars}
            close={closeModal}
            icon=""
            title={t('title-open-modal-star')}
            go={t('title-open-modal-star')}
            modalDesign
            classNameContent="modal-confirm-star"
            showQuestionStar
            idService={idService}
            onSubmitSatisfactionQuestionnaire={onSubmitSatisfactionQuestionnaire}
            star={star}
            setStar={setStar}
          />
        ) : (
          ''
        )}

        {openModalLeft ? (
          <PopUp
            open={openModalLeft}
            close={closeModal}
            icon={alertIcon}
            title={t('title-modal-left')}
            description={t('description-modal-left')}
            back={t('keep-it')}
            go={t('yes-accept')}
            accept={acceptModalLeft}
            modalDesign
            btnAccept
            btnClose
            classNameBase="block-modal-left"
            classNameContent="modal-left"
            classNameBtn="btn_modal pink"
          />
        ) : (
          ''
        )}

        {openModalRequestReject ? (
          <PopUp
            open={openModalRequestReject}
            close={closeModal}
            icon={alertIcon}
            title={t('title-modal-request-reject')}
            description={t('description-modal-request-reject')}
            back={t('keep-it')}
            go={t('confirm')}
            modalDesign
            btnAccept={false}
            btnClose={false}
            classNameBase="block-modal-left"
            classNameContent="modal-left"
            classNameBtn="btn_modal pink"
            showQuestion
            question={t('question')}
            answers={[t('answer'), t('answer-two'), t('answer-three')]}
            idService={idService}
            onSubmit={onSubmit}
          />
        ) : (
          ''
        )}

        {!reload ? (
          <Spinner text={t('alert:reload')}> </Spinner>
        ) : (
          <>
            {!dataMaintenance ? (
              <>
                <div className="content_dynamic history">
                  <Row className="content_history">
                    <div className="header-content">
                      <div className="info-tittle">
                        <h1 className="title-maintenances">{t('title')}</h1>
                      </div>
                    </div>
                    <div className="not-services">
                      <img
                        src={notMaintenance}
                        className="img-not-maintenances"
                        alt={t('alt:not_mantenice')}
                      />
                      <h4 className="center">{t('alert1')} </h4>
                    </div>
                  </Row>
                </div>
              </>
            ) : (
              <div className="content_dynamic history">
                <Row className="content_maintenace">
                  <div className="header-content">
                    <div className="info-tittle">
                      <h1 className="title-maintenances">{t('title')}</h1>
                    </div>
                    <div className="info-notification">
                      <div className="img-container-maintenace">
                        <p className="tittle-container">{t('new-requests')}</p>
                        <h5 className="value-container">{newMaintenances}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="modal-display row-states">
                    <div className="tittle-filter">
                      <p className="bold txt spacy-top">{t('filter-date')}</p>
                    </div>
                    <div className="block-datepicker">
                      <div className="input-filter">
                        <label htmlFor="name" className="col-form-label">
                          {t('date-initial')}
                        </label>
                        <br />
                        <DatePicker
                          showToday
                          value={dateInitial}
                          defaultValue={dateInitial}
                          format={dateFormatList}
                          selected={dateInitial}
                          suffixIcon={<img src={calendarIcon} alt={t('alt:calendar')} />}
                          placeholder=""
                          onChange={onChangeInitial}
                        />
                      </div>
                      <div className="input-filter">
                        <label htmlFor="name" className="col-form-label">
                          {t('date-final')}
                        </label>
                        <br />
                        <DatePicker
                          showToday
                          value={dateFinal}
                          defaultValue={dateFinal}
                          format={dateFormatList}
                          selected={dateFinal}
                          suffixIcon={<img src={calendarIcon} alt={t('alt:calendar')} />}
                          placeholder=""
                          onChange={onChangeFinal}
                        />
                      </div>
                    </div>
                    <div className="button-filter">
                      <Button
                        className="btn-filter gray"
                        variant="light"
                        onClick={() => useSetFilterDate(true)}
                      >
                        {t('filter')}
                      </Button>
                    </div>
                  </div>
                  <div className="type-status">
                    <p className="bold txt">{t('status')}</p>
                    <div className="content-status">
                      <p>
                        <span className="circle status-1" /> {t('unassigned')}
                      </p>
                      <p>
                        <span className="circle status-2" /> {t('assigned')}
                      </p>
                      <p>
                        <span className="circle status-3" /> {t('in-progress')}
                      </p>
                      <p>
                        <span className="circle status-10" /> {t('in-approval')}
                      </p> 
                      <p>
                        <span className="circle status-11" /> {t('approved')}
                      </p>  
                    </div>
                  </div>
                </Row>
                <Row className="no-gutters">
                  {maintenances.length <= 0 ? (
                    <div className="content_not_mantenaice ">
                      <img
                        src={notMaintenance}
                        className="img-not-maintenances small"
                        alt={t('alt:not_mantenice')}
                      />
                      <h4>{t('alert2')}</h4>
                    </div>
                  ) : (
                    <>
                    
                      <Accordion className="col-12">
                        {maintenances.map(
                          (maintenance, index) =>
                            index >= minIndex &&
                            index < maxIndex && (
                              <div key={index}>
                                {messageAlertInApproval && idService == maintenance.id && (
                                  <div className="error_input">
                                    <p>
                                      <img src={alert} alt={t('alt:notification')} />
                                      {textMessageAlertInApproval}
                                    </p>
                                  </div>
                                  
                                )}
                                {!maintenance.read ? (
                                  <div className="circle2 read spacy-read" />
                                ) : (
                                  ''
                                )}
                                <Card className="main-card" key={maintenance.id}>
                                  <OverlayTrigger
                                    placement="right"
                                    overlay={
                                      <Tooltip id={`tooltip-id-${maintenance.id}`}>
                                        {`LEO-${maintenance.id}`}
                                      </Tooltip>
                                    }
                                  >
                                    <div className={`borde-status status-${maintenance.id_status === 12 ? 10 : maintenance.id_status}`} />
                                  </OverlayTrigger>
                                  <Card.Header
                                    className={`card-maintenances ${activeKey === maintenance.id ? 'head-show' : 'head-hidden'
                                      }`}
                                  >
                                    <Row>
                                      <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                                        <CustomToggle
                                          as={Button}
                                          eventKey={maintenance.id}
                                          handleClick={() => {
                                            if (activeKey === maintenance.id) {
                                              setActiveKey(null);
                                            } else {
                                              setActiveKey(maintenance.id);
                                            }
                                          }}
                                        >
                                          <p className="title-2">{t('date-hour-request')}</p>
                                          <p className="txt">
                                            <Moment format="DD/MM/YYYY hh:mm a">
                                              {maintenance.created_at}
                                            </Moment>
                                          </p>
                                        </CustomToggle>
                                      </Col>
                                      <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                                        <CustomToggle
                                          as={Button}
                                          eventKey={maintenance.id}
                                          handleClick={() => {
                                            if (activeKey === maintenance.id) {
                                              setActiveKey(null);
                                            } else {
                                              setActiveKey(maintenance.id);
                                            }
                                          }}
                                        >
                                          <p className="title-2">{t('date-hour-service')}</p>
                                          <p className="txt">
                                            <Moment format="DD/MM/YYYY">
                                              {maintenance.date_service}
                                            </Moment>{' '}
                                            <Moment
                                              date={hourChange(maintenance.service_hours)}
                                              format="hh:mm a"
                                            />
                                          </p>
                                        </CustomToggle>
                                      </Col>
                                      <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                                        <div className="arrow-card">
                                          <p className="title-2">{t('type-service')}</p>
                                          <p className="txt">
                                            {maintenance.service_type.split(',')[0]}
                                            {maintenance.service_type.split(',').length > 1 ? (
                                              <OverlayTrigger
                                                placement="top"
                                                className="tooltip-info vehicle"
                                                id="vehicle"
                                                delay={{ show: 50, hide: 500 }}
                                                overlay={(componentProps) =>
                                                  RenderTooltip({
                                                    ...componentProps,
                                                    items: maintenance.service_type.split(','),
                                                    id: 'tooltip-type-services',
                                                    classtxt: 'tooltip-txt-info ',
                                                  })
                                                }
                                              >
                                                <img
                                                  className="info-maintenance-company"
                                                  src={eye}
                                                  alt={t('alt:tooltip')}
                                                />
                                              </OverlayTrigger>
                                            ) : (
                                              ''
                                            )}
                                          </p>
                                        </div>
                                      </Col>
                                      <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                                        {(maintenance.option === 'Accept' || maintenance.id_status === 11) &&
                                          (maintenance.id_status === 2 ||
                                            maintenance.id_status === 3 ||  maintenance.id_status === 11 ) ? (
                                          <Dropdown className="dropdown-custom">
                                            <p className="title-2">{t('status-service')}</p>
                                            <Dropdown.Toggle
                                              show
                                              as={Toggle}
                                              className="btn-status dropdown-toggle"
                                              id="dropdown-basic"
                                              eventKey={maintenance.id}
                                            >
                                              <p className={`txt color-${maintenance.id_status}`}>
                                                {maintenance.status.status}
                                              </p>
                                              {arrow === true &&
                                                maintenance.id === activeKeyStatus ? (
                                                <img
                                                  className="arrow-status"
                                                  src={arrowUp}
                                                  alt={t('alt:show_information')}
                                                />
                                              ) : (
                                                <img
                                                  className="arrow-status"
                                                  src={arrowDown}
                                                  alt={t('alt:hidden_information')}
                                                />
                                              )}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu flip="true" className="status">
                                              <Dropdown.Item
                                                className="dropdown-item-status"
                                                onClick={
                                                  maintenance.id_status === 2
                                                    ? () => changeInProcess(maintenance.id)
                                                    : maintenance.id_status === 3
                                                      ? () => changeInApproval(maintenance.id)  
                                                      : () => satisfactionQuestionnaire(maintenance.id)
                                                }
                                              >
                                                {
                                                  maintenance.id_status === 2 ? (
                                                    <p className="txt color-3">{t('in-progress')}</p>
                                                  ) : maintenance.id_status === 3 ? (
                                                    <p className="txt color-2">{t('in-approval')}</p>
                                                  ) : (
                                                    <p className="txt color-4">{t('finalized')}</p>
                                                  )
                                                }
                                              </Dropdown.Item>
                                              {maintenance.id_status === 11 &&
                                                (maintenance.additional_approvals || []).filter(
                                                  (a) => a.status === 'pending' || a.status === 'approved'
                                                ).length < 2 && (
                                                <Dropdown.Item
                                                  className="dropdown-item-status"
                                                  onClick={() => openAdditionalApprovalModal(maintenance.id)}
                                                >
                                                  <p className="txt color-10">{t('request-additional-approval')}</p>
                                                </Dropdown.Item>
                                              )}
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        ) : (
                                          <CustomToggle
                                            as={Button}
                                            eventKey={maintenance.id}
                                            handleClick={() => {
                                              if (activeKey === maintenance.id) {
                                                setActiveKey(null);
                                              } else {
                                                setActiveKey(maintenance.id);
                                              }
                                            }}
                                          >
                                            <p className="title-2">{t('status-service')}</p>
                                            {maintenance.id_status === 12 ? (
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                  <Tooltip id={`tooltip-additional-approval-${maintenance.id}`}>
                                                    {t('in-additional-approval')}
                                                  </Tooltip>
                                                }
                                              >
                                                <div style={{ display: 'flex', alignItems: 'center',justifyContent: 'space-between', gap: '4px' }}>
                                                  <span className="txt-status txt color-10" style={{ position: 'static', display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'default' }}>
                                                    {t('in-approval')}
                                                  </span>
                                                  <span style={{
                                                      position: 'relative',
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      width: '14px',
                                                      height: '14px',
                                                      borderRadius: '50%',
                                                      border: '1.5px solid currentColor',
                                                      fontSize: '10px',
                                                      fontWeight: 'bold',
                                                      lineHeight: '1',
                                                      flexShrink: 0,
                                                    }}>!</span>
                                                  </div>
                                              </OverlayTrigger>
                                            ) : (
                                              <p className={`txt-status txt color-${maintenance.id_status}`}>
                                                {maintenance.status.status}
                                              </p>
                                            )}
                                          </CustomToggle>
                                        )}
                                      </Col>
                                      <Col className="toggle-matenaice">
                                        {maintenance.id_status !== 3 && maintenance.id_status !== 10 && maintenance.id_status !== 11 ? (
                                          maintenance.option === 'Accept' ? (
                                            <Button
                                              className="btn-cancel"
                                              onClick={() => confirmCancel(maintenance.id)}
                                            >
                                              {t('cancel-service')}
                                            </Button>
                                          ) : (
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                className="btn-option dropdown-toggle"
                                                id="dropdown-basic"
                                              >
                                                {t('option')}
                                                <img
                                                  className="option-points"
                                                  src={moreVertical}
                                                  alt={t('alt:show_options')}
                                                />
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu flip="true">
                                                <Dropdown.Item
                                                  onClick={() => openModalAccept(maintenance.id)}
                                                >
                                                  {t('accept')}
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                  onClick={() => openModalDeny(maintenance.id)}
                                                >
                                                  {t('reject')}
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          )
                                        ) : (
                                          ''
                                        )}
                                      </Col>
                                      <div className="toggle-icon">
                                        <CustomToggle
                                          as={Button}
                                          eventKey={maintenance.id}
                                          handleClick={() => {
                                            if (activeKey === maintenance.id) {
                                              setActiveKey(null);
                                            } else {
                                              setActiveKey(maintenance.id);
                                            }
                                          }}
                                        >
                                          {activeKey === maintenance.id ? (
                                            <img
                                              className="img-arrow-last"
                                              src={arrowUp}
                                              alt={t('alt:hidden_information')}
                                            />
                                          ) : (
                                            <img
                                              className="img-arrow-last"
                                              src={arrowDown}
                                              alt={t('alt:show_information')}
                                            />
                                          )}
                                        </CustomToggle>
                                      </div>
                                    </Row>
                                  </Card.Header>
                                  <Accordion.Collapse eventKey={maintenance.id}>
                                    <Card.Body className="description-card">
                                      <Row>
                                        <Col xs={12} md={12} className="col-collapse">
                                          <h6 className="bold">{t('observations')}</h6>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col xs={12} md={3} className="col-collapse">
                                          <p className="second title-2">{t('name')}</p>
                                          <p className="txt">
                                            {`${maintenance.driver.name} ${maintenance.driver.last_name}`}
                                          </p>
                                        </Col>
                                        <Col xs={6} md={3} className="col-collapse">
                                          <p className="second title-2">{t('license-plate')}</p>
                                          <p className="txt">
                                            {maintenance.vehicle.licenseplate}
                                            <OverlayTrigger
                                              placement="top"
                                              className="tooltip-info vehicle"
                                              id="vehicle"
                                              delay={{ show: 50, hide: 500 }}
                                              overlay={(componentProps) =>
                                                RenderTooltip({
                                                  ...componentProps,
                                                  text: `${t('brand')}`,
                                                  text2: `${t('model')}`,
                                                  text3: `${t('color')}`,
                                                  brand: maintenance.vehicle.brand,
                                                  model: maintenance.vehicle.model,
                                                  color: maintenance.vehicle.color,
                                                  id: 'tooltip-info-vehicle',
                                                  classtxt: 'tooltip-txt-info',
                                                })
                                              }
                                            >
                                              <img
                                                className="info-maintenance-company"
                                                src={eye}
                                                alt={t('alt:tooltip')}
                                              />
                                            </OverlayTrigger>
                                          </p>
                                        </Col>
                                        <Col xs={6} md={3} className="col-collapse">
                                          <p className="second title-2">{t('image')}</p>
                                          <p className="txt">
                                            {maintenance.image ? (
                                              <a
                                                className="a-vehicle"
                                                href={`${urlPublicS3()}/${maintenance.image}`}
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                {t('see-image')}
                                              </a>
                                            ) : (
                                              t('without-image')
                                            )}
                                          </p>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col xs={6} md={3} className="col-collapse">
                                          <p className="second title-2">{t('garage')}</p>
                                          <p className="txt">
                                            {dataGarage.name} - {maintenance.garage.address}
                                          </p>
                                        </Col>
                                        {maintenance.garage.garage_car === 1 ? (
                                          <Col xs={6} md={6} className="col-collapse">
                                            <p className="second title-2">{t('address-service')}</p>
                                            <p className="txt">{maintenance.address_service}</p>
                                          </Col>
                                        ) : (
                                          ''
                                        )}
                                      </Row>
                                      <Row>
                                        <Col xs={12} md={12} className="col-collapse">
                                          <p className="second title-2">{t('description')}</p>
                                          <p className="txt txt observations-mechanics">
                                            {maintenance.description}
                                          </p>
                                        </Col>
                                      </Row>
                                     {maintenance.id_status !== 1 && maintenance.id_status !== 2 && maintenance.id_status !== 5 && (
                                        <Row>
                                          <hr></hr>
                                          <Col>
                                            <FormInProcess id={maintenance.id} dataForm={setDataFormInApproval} quotation={maintenance.quotation} img_quotation={maintenance.img_quotation} km_odometer_service={maintenance.km_odometer_service} status={maintenance.id_status}/>
                                          </Col>
                                        </Row>
                                      )} 
                                       {maintenance.id_status === 11   && (
                                        <>
                                          <Row>
                                            <hr></hr>
                                            <Col xs={6} md={3} className="col-collapse">
                                              <p className="second title-2">{t('aviso')}</p>
                                              <p className="txt">{maintenance.aviso}</p>
                                            </Col>
                                            <Col xs={6} md={3} className="col-collapse">
                                              <p className="second title-2">{t('comentarios')}</p>
                                              <p className="txt">{maintenance.comments}</p>
                                            </Col>
                                          </Row>

                                          <Row>
                                              <TableSelectedParts parts={(() => {
                                                const base = maintenance.selected_num_part ? JSON.parse(maintenance.selected_num_part) : [];
                                                const map = {};
                                                base.forEach((p) => { map[String(p.id)] = { ...p, quantity: Number(p.quantity) }; });
                                                (maintenance.additional_approvals || [])
                                                  .filter((a) => a.status === 'approved')
                                                  .forEach((a) => {
                                                    const aParts = typeof a.selected_num_part === 'string'
                                                      ? JSON.parse(a.selected_num_part || '[]')
                                                      : (a.selected_num_part || []);
                                                    aParts.forEach((ap) => {
                                                      const id = String(ap.id);
                                                      const qty = Number(ap.quantity);
                                                      if (map[id]) { map[id] = { ...map[id], quantity: map[id].quantity + qty }; }
                                                      else if (qty > 0) { map[id] = { ...ap, quantity: qty }; }
                                                    });
                                                  });
                                                return Object.values(map).filter((p) => p.quantity > 0);
                                              })()} />
                                          </Row>
                                        </>
                                      )}
                                      {maintenance.additional_approvals && maintenance.additional_approvals.length > 0 && (
                                        <AdditionalApprovalsHistory
                                          approvals={maintenance.additional_approvals}
                                          serviceId={maintenance.id}
                                        />
                                      )}
                                    </Card.Body>
                                  </Accordion.Collapse>

                                  {maintenance.id_status !== 3 && maintenance.id_status !== 10 && maintenance.id_status !== 11 ? (
                                    maintenance.option === 'Accept' ? (
                                      <div className="block-btn-opt">
                                        <Button
                                          className="cancel-btn"
                                          onClick={() => confirmCancel(maintenance.id)}
                                        >
                                           {t('cancel-service')}
                                        </Button>
                                      </div>
                                    ) : (
                                      <div className="block-btn-opt">
                                        <Button
                                          className=""
                                          onClick={() => openModalDeny(maintenance.id)}
                                        >
                                          {t('reject')}
                                        </Button>
                                        <Button
                                          className=""
                                          onClick={() => openModalAccept(maintenance.id)}
                                        >
                                          {t('accept')}
                                        </Button>
                                      </div>
                                    )
                                  ) : (
                                    ''
                                  )}
                                </Card>
                              </div>
                            )
                        )}
                      </Accordion>
                      <Pagination
                        className="col-12"
                        size="small"
                        defaultCurrent={1}
                        total={maintenances.length}
                        defaultPageSize={cardPerPage}
                        current={currentPage}
                        onChange={handleChange}
                      />
                    </>
                  )}
                </Row>
              </div>
            )}
          </>
        )}
      </>
    </Template>
  );
}

Maintenance.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['maintenance', 'alt'])(Maintenance);
